import React from 'react'

import FcaServices from '@/components/misc/CompanyProfile/tabs/ServicesAndExpertiseTab/components/FcaServices'
import FcaServicesAndExpertiseAreas from '@/components/misc/CompanyProfile/tabs/ServicesAndExpertiseTab/components/FcaServicesAndExpertiseAreas'
import { DirectoryFcaEntity } from '@/types/entities'
import { CompanyProfileItemCompany } from '@/types/responses/companies'

interface Props {
  company: CompanyProfileItemCompany | null
  companyServices: CompanyProfileItemCompany['services']
  expertiseAreas: CompanyProfileItemCompany['expertiseAreas']
  fcaServices: DirectoryFcaEntity['services']
}

const ServicesAndExpertise: React.FC<Props> = ({
  company,
  companyServices,
  expertiseAreas,
  fcaServices,
}) => {
  if (companyServices.length > 0 || expertiseAreas.length > 0) {
    return (
      <FcaServicesAndExpertiseAreas
        company={company}
        companyServices={companyServices}
        expertiseAreas={expertiseAreas}
      />
    )
  }

  return <FcaServices services={fcaServices} />
}

export default ServicesAndExpertise
